import { useEffect } from 'react';
import { useUploadTaskStore, selectActiveTaskCount } from '../store/uploadTaskStore';

/**
 * 存在进行中任务时拦截页面刷新 / 关闭。
 *
 * 注意：浏览器不允许自定义文案，只会出现「离开此网站？」的默认提示。
 * 仅在存在 uploading / saving 任务时注册，任务全部结束立即移除，
 * 避免用户正常离开时被无谓拦截。saving 阶段也拦，防止用户以为没保存而重复上传。
 */
export const useBeforeUnloadGuard = () => {
  const hasActive = useUploadTaskStore(selectActiveTaskCount) > 0;

  useEffect(() => {
    if (!hasActive) return;
    const handler = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
      return '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [hasActive]);
};
